import { render, staticRenderFns } from "./MongoSortInput.vue?vue&type=template&id=3cff5a7c&scoped=true&"
import script from "./MongoSortInput.vue?vue&type=script&lang=js&"
export * from "./MongoSortInput.vue?vue&type=script&lang=js&"
import style0 from "./MongoSortInput.vue?vue&type=style&index=0&id=3cff5a7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cff5a7c",
  null
  
)

export default component.exports